import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useScrollReveal } from "../hooks/useScrollReveal";

const CancellationPolicyPage = () => {
  const headerReveal = useScrollReveal({ threshold: 0.1 });
  const contentReveal = useScrollReveal({ threshold: 0.05 });

  return (
    <div className="min-h-screen visitor-page">
      <Navbar />

      <section className="bg-gradient-to-br from-white via-domigo-pink/10 to-domigo-purple/5 py-16 lg:py-24">
        <div
          ref={headerReveal.ref}
          className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${
            headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
          }`}
        >
          <h1 className="text-4xl lg:text-6xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent leading-tight mb-6">
            💰 Cancellation &amp; Refund Policy
          </h1>
          <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Last Updated: 22-04-2026
          </p>
        </div>
      </section>

      <section className="bg-gradient-to-b from-white to-gray-50 py-16 lg:py-24">
        <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8">
          <div
            ref={contentReveal.ref}
            className={`max-w-[1020px] mx-auto bg-white/95 rounded-3xl p-6 sm:p-10 lg:p-12 shadow-soft ring-1 ring-gray-100 text-left transition-all duration-1000 ${
              contentReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
            }`}
          >
            <div className="pb-7 border-b border-gray-100">
              <p className="text-lg text-gray-600 leading-relaxed">This policy outlines the terms for cancellation and refunds for services booked with Domigo.</p>
            </div>

            <div className="space-y-4 py-7 border-b border-gray-100">
              <h2 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">1. Booking Cancellation</h2>
              <p className="text-lg text-gray-600 leading-relaxed">Cancellation requests must be made in advance.</p>
              <p className="text-lg text-gray-600 leading-relaxed">Approval of cancellation is subject to Domigo's discretion and operational policies.</p>
            </div>

            <div className="space-y-4 py-7 border-b border-gray-100">
              <h2 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">2. Refund Eligibility</h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-4">Refunds, if applicable, will depend on:</p>
              <ul className="list-disc pl-6 text-lg text-gray-600 leading-relaxed space-y-2 mb-4">
                <li>Time of cancellation</li>
                <li>Type of service booked</li>
                <li>Operational costs already incurred</li>
              </ul>
            </div>

            <div className="space-y-4 py-7 border-b border-gray-100">
              <h2 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">3. Non-Refundable Cases</h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-4">Refunds may not be applicable in the following situations:</p>
              <ul className="list-disc pl-6 text-lg text-gray-600 leading-relaxed space-y-2 mb-4">
                <li>Last-minute cancellations</li>
                <li>No-shows (failure to check-in)</li>
                <li>Partial usage of services</li>
                <li>Violation of terms or policies</li>
              </ul>
            </div>

            <div className="space-y-4 py-7 border-b border-gray-100">
              <h2 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">4. Refund Process</h2>
              <p className="text-lg text-gray-600 leading-relaxed">Approved refunds will be processed within a reasonable time frame.</p>
              <p className="text-lg text-gray-600 leading-relaxed">Refunds will be issued via the original payment method unless stated otherwise.</p>
            </div>

            <div className="space-y-4 py-7 border-b border-gray-100">
              <h2 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">5. Rescheduling</h2>
              <p className="text-lg text-gray-600 leading-relaxed">Bookings may be rescheduled based on availability.</p>
              <p className="text-lg text-gray-600 leading-relaxed">Requests must be made in advance and are subject to approval.</p>
            </div>

            <div className="space-y-4 py-7 border-b border-gray-100">
              <h2 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">6. Service Issues</h2>
              <p className="text-lg text-gray-600 leading-relaxed">In case of any service-related concerns, customers are encouraged to contact Domigo immediately. We will review and address issues on a case-by-case basis.</p>
            </div>

            <div className="space-y-4 pt-7">
              <h2 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">7. Policy Updates</h2>
              <p className="text-lg text-gray-600 leading-relaxed">Domigo reserves the right to update or modify this policy at any time without prior notice.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CancellationPolicyPage;